module.exports = __webpack_public_path__ + "static/media/bd.86da4b8b.svg";